import './style.css.js';
import '@magnetic/theme';
import { useAnalytics } from '@magnetic/analytics';
import { useClassNames } from '@magnetic/hooks';
import React, { forwardRef, useMemo, useCallback } from 'react';
import { CheckboxSvg } from './checkbox-svg.js';
import { RadioSvg } from './radio-svg.js';
import { ToggleSvg } from './toggle-svg.js';

const componentMapping = {
  checkbox: {
    svg: /* @__PURE__ */ React.createElement(CheckboxSvg, null),
    role: "checkbox",
    analyticsComponent: "checkbox"
  },
  toggle: {
    svg: /* @__PURE__ */ React.createElement(ToggleSvg, null),
    role: "switch",
    analyticsComponent: "toggle"
  },
  radio: {
    svg: /* @__PURE__ */ React.createElement(RadioSvg, null),
    role: "switch",
    analyticsComponent: "radio"
  }
};
const Switch = forwardRef(
  ({
    analytics,
    checked = false,
    children,
    className,
    disabled,
    indeterminate,
    kind = "toggle",
    onClick,
    size = "md",
    ...rest
  }, ref) => {
    const { analyticsComponent, role, svg } = useMemo(
      () => componentMapping[kind],
      [kind]
    );
    const { sendAnalytics } = useAnalytics();
    const classNames = useClassNames(
      "mds-switch",
      `mds-switch-size-${size}`,
      `mds-switch-kind-${kind}`,
      className
    );
    const handleClick = useCallback(
      (event) => {
        if ((analytics == null ? void 0 : analytics.events.includes("click")) && !disabled) {
          sendAnalytics({
            ...analytics,
            component: analyticsComponent,
            event: "click"
          });
        }
        onClick == null ? void 0 : onClick(event);
      },
      [analytics, disabled, sendAnalytics, analyticsComponent, onClick]
    );
    return /* @__PURE__ */ React.createElement("button", {
      ref,
      ...rest,
      "aria-checked": indeterminate ? "mixed" : checked,
      className: classNames,
      disabled,
      onClick: handleClick,
      role,
      type: "button"
    }, svg, children);
  }
);
const Checkbox = forwardRef(
  (props, ref) => /* @__PURE__ */ React.createElement(Switch, {
    ...props,
    kind: "checkbox",
    ref
  })
);
const Toggle = forwardRef(
  (props, ref) => /* @__PURE__ */ React.createElement(Switch, {
    ...props,
    kind: "toggle",
    ref
  })
);

export { Checkbox, Switch, Toggle };
//# sourceMappingURL=index.js.map
